var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-outer-wrapper",class:{ active: !!_vm.preset }},[_c('div',{ref:"wrapper",staticClass:"avatar-inner-wrapper"},[(_vm.preset)?_c('img',{attrs:{"src":_vm.preset.largeImageBase64}}):_c('img',{attrs:{"src":require("@/assets/images/avatar_placeholder.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }